import React from "react";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Register from "../components/register/Register";
import Footer from "../components/Footer";

function RegisterPage() {
  const navigate = useNavigate();

  const handleRegistrationSuccess = () => {
    // după register -> mergi la login
    navigate("/login", { replace: true });
  };

  return (
    <div>
      <Header />
      <Register onRegistrationSuccess={handleRegistrationSuccess} />
      <Footer />
    </div>
  );
}

export default RegisterPage;